export const FONT_FAMILIES: string[] = [
  "Inter",
  "Arial",
  "Helvetica Neue",
  "Georgia",
  "Times New Roman",
  "Courier New",
];

